import { render, staticRenderFns } from "./nostartPromot.vue?vue&type=template&id=805789cc&scoped=true&"
import script from "./nostartPromot.vue?vue&type=script&lang=js&"
export * from "./nostartPromot.vue?vue&type=script&lang=js&"
import style0 from "./nostartPromot.vue?vue&type=style&index=0&id=805789cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805789cc",
  null
  
)

export default component.exports